import { Link } from "react-router-dom";
import styles from "./LinkWrapper.module.scss";
const LinkWrapper = ({ link, component, color = "black" }) => {
  return (
    <div className={styles["link-wrapper"]}>
      <Link style={{ color: color }} to={link} className={styles["link"]}>
        {component}
      </Link>
    </div>
  );
};

export default LinkWrapper;
